export default __webpack_public_path__ + "static/media/Hamburger-Menu-Icon.b916d173.svg";